module.exports = __webpack_public_path__ + "img/rdd.94f8dece.svg";